import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import * as dbInspections from 'serviceWorker/db/inspections/inspections';
import {
  broadcastUploadedInspectionError,
  broadcastUploadedInspection,
  broadcastUpdatedInspection,
  broadcastDeletedInspection,
  broadcastRestoredInspection,
} from 'serviceWorker/broadcasts/inspections';
import { isInspectionOutcome } from 'shared/domain/inspection/inspectionOutcomes';
import { neverReached } from 'shared/utils/neverReached';
import { responseErrorOf } from './responseError';
import { storeServerAnswer } from 'serviceWorker/broadcasts/storeServerAnswer';
import { swLog } from 'serviceWorker/helpers/makeSwLogger';
import { projectIdOfRequest, scopeOfProject } from 'serviceWorker/helpers/dataScope';
import { LogLevel } from 'shared/types/logger';

/**
 * Stores the created inspection first: the page opens it right after the
 * answer (PT-7176). An answer that is not an inspection rejects the create
 * instead of being stored.
 */
async function answerCreatedInspection(answer: unknown, uniqueId: string, projectId: string | undefined): Promise<void> {
  if (!isInspectionOutcome(answer)) {
    broadcastUploadedInspectionError(new Error('Unexpected answer to an inspection create'), uniqueId);
    return;
  }
  await storeServerAnswer('inspection', () => scopeOfProject(projectId).write(() => dbInspections.addBatch([answer])));
  broadcastUploadedInspection(answer, uniqueId);
}

export function broadcastInspectionResponse(
  request: HttpRequestEntity,
  response: unknown
): void {
  const error = responseErrorOf(response);
  if (error) {
    return broadcastUploadedInspectionError(error, request.data.uniqueId);
  }

  switch (request.method) {
    case 'POST':
      return void answerCreatedInspection(response, request.data.uniqueId, projectIdOfRequest(request)).catch((error: unknown) =>
        swLog('Could not answer the inspection create', LogLevel.ERROR, error, { query: { uniqueId: request.data.uniqueId } })
      );
    case 'PUT':
      return broadcastUpdatedInspection(response, request.data.uniqueId);
    case 'DELETE':
      return broadcastDeletedInspection(response, request.data.uniqueId);
    case 'GET':
      return broadcastRestoredInspection(response, request.data.uniqueId);
    default:
      neverReached(request.method);
  }
}
